<template>
  <div class="flex flex-column mr-8 md:mr-8">
    <span class="inline-block font-medium text-base mr-2">
      {{ t('dataExplorer.orderFile.orderNumber', [order.idOrder]) }} - {{ t('dataExplorer.orderFile.orderReference', [order.orderReference]) }}
    </span>
    <div class="flex align-items-center gap-2 mt-2">
      <span
        class="font-medium text-500 text-sm"
      >
        {{ formatDate(order.date, 'YYYY-MM-DD HH:mm:ss', 'DD/MM/YYYY HH:mm:ss') }}
      </span>
      <span
        v-if="sourceLabel"
        class="source-badge"
      >
        <i class="far fa-database" />
        {{ sourceLabel }}
      </span>
    </div>
  </div>
  <div class="mt-2 md:mt-0 ml-0 md:ml-8 flex flex-column align-items-center">
    <span
      class="mb-2 order-price"
    >
      {{ formatNumberToCurrency(order.amount, order.currency) }}
    </span>
    <SpmButton
      :label="t('dataExplorer.contactFile.fields.addresses.openAddressBtn')"
      icon="fa-light fa-circle-info"
      class-style="p-button p-button-secondary"
      @click="openOrderFile"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';

import SpmButton from '@/components/spm-primevue/SpmButton.vue';

import { formatDate } from '@/helpers/Date';
import { formatNumberToCurrency } from '@/helpers/Number';

import {
  Order,
} from '@/types/data-explorer-types';

import { useStore } from '@/store';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  name: 'OrderItem',

  components: {
    SpmButton,
  },

  props: {
    order: {
      type: Object as PropType<Order>,
      required: true,
    },

    keyName: {
      type: String,
      required: true,
    },

    sourceLabel: {
      type: String,
      default: '',
    },
  },

  setup (props) {
    const { t } = useI18n();
    const store = useStore();

    const openOrderFile = () => {
      store.dispatch('dataExplorer/openOrderFile', { idOrder: props.order.idOrder, keyName: props.keyName });
    };

    return {
      t,

      formatDate,
      formatNumberToCurrency,
      openOrderFile,
    };
  }
})
</script>

<style lang="scss" scoped>
.order-price {
  color: $brand-color-primary;
  font-size: 1.5rem;
}

.source-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  font-size: 0.6875rem;
  font-weight: 600;
  padding: 0.0625rem 0.5rem;
  border-radius: 20px;
  background: #e0e7ff;
  color: #3730a3;

  i {
    font-size: 0.625rem;
  }
}
</style>
